import Courses from './components/courses/Courses';
import initCourseStructureAccordion from "./components/courses/course-structure-accordion";
import initCourseDetails from "./components/courses/course-details";

class CoursesAndMajorsApp {
    constructor() {
        this._courses = new Courses();

        this.initModernComponents();
    }

    initModernComponents() {
        initCourseStructureAccordion();
        initCourseDetails();
    }
}

const coursesAndMajorsApp = new CoursesAndMajorsApp();